import * as React from 'react';
import Loader from '../../../Components/Loader';
import { Modal } from '../../../Components/Modal';
import { AdminIcon } from '../../../Icons/AdminIcon';
import '../AdminGroups.css'
interface EditGroupModalProps {
  group: {
    id: string;
    name: string;
    description: string;
  };
  isSaving: boolean;
  onSave: (updated: { name: string; description: string }) => Promise<void>;
  onClose: () => void;
}

export const EditGroupModal = ({ group, isSaving, onSave, onClose }: EditGroupModalProps) => {
  const [name, setName] = React.useState(group.name);
  const [description, setDescription] = React.useState(group.description);

  return (
    <Modal className="admin-group-modal-layout" onClose={onClose}>
      <div className="admin-group-modal-close">
        <button type="button" aria-label="Stäng" onClick={onClose}>
          <AdminIcon.CrossClose fill="hsl(var(--primary))" width={18} />
        </button>
      </div>

      <div className="sheet-header-container">
        <h2 className="sheet-header-text">Redigera grupp</h2>
        <p className="sheet-header-paragraph">
          Uppdatera informationen om gruppen nedan.
        </p>
      </div>

      <div className="admin-group-modal-form">
        <label className="block-text-sm-font-medium-text-gray-700-mb-1">Gruppnamn</label>
        <input
          className="admingroups-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <label className="block-text-sm-font-medium-text-gray-700-mb-1">Beskrivning</label>
        <textarea
          className="admingroups-input"
          rows={4}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>

      <div className="admin-group-modal-footer">
        <button
          type="submit"
          className="sheet-form-submit-button"
          onClick={() => onSave({ name, description })}
        >
          {isSaving ? (
            <>
              <Loader loaderSize="SMALL" bgColor="white" /> Sparar
            </>
          ) : (
            <>
              <AdminIcon.Save width={16} height={16} fill="white" /> Spara ändringar
            </>
          )}
        </button>
      </div>
    </Modal>
  );
};
